import { CALCULATOR_TYPES } from "constants/calculator";

export const checkFieldConfiguration = (
  calculatorType: (typeof CALCULATOR_TYPES)[keyof typeof CALCULATOR_TYPES],
  fields: string[]
) => {
  return !fields.some((field) => field === calculatorType);
};
